import { gql } from "graphql-tag";

export const APPLICANT_SEARCH_QUERY = gql`
  query ApplicantSearch(
    $elasticQuery: ElasticQuery!,
    $interestListIds: [ID!]!,
    $page: Int,
    $pageSize: Int
  ) {
    applicantSearch(
      elasticQuery: $elasticQuery,
      interestListIds: $interestListIds,
      page: $page,
      pageSize: $pageSize
      ) {
      page
      pageSize
      hits
      items {
        userId
        applicantName
        applicantFirstName
        applicantLastName
        applicantPhone
        applicantEmail
        householdMember0FirstName
        householdMember0LastName
        residenceCity
        householdIncome
        isComplete
        hasPositionNumber
        unitSize1br
        hasUserId
        positionNumber
        hasStar
        id
        interestListId
        skips
        status
        weight
        lastStatusChange

        applicant_dob

        applicant_email
        applicant_first_name
        applicant_last_name
        applicant_name
        applicant_phone

        has_household_income
        has_position_number
        has_star
        household_count
        household_gross_annual_income
        household_income
        household_member_0_email
        household_member_0_first_name
        household_member_0_gender
        household_member_0_last_name
        household_member_0_middle_name
        interest_list_id
        position_number
        pref_lang
        submitted_at
        unit_size_1br
        unit_size_1br_den
        unit_size_2br
        unit_size_3br
        unit_size_4br
        unit_size_5br
        unit_size_shared
        unit_size_sro
        unit_size_studio
        user_id

        is_duplicate
        household_has_housing_authority_voucher
        household_receives_other_housing_assistance
      }
    }
  }
  `;
// snake-cased values ruin the gql:gen:both command.
// temp solution is to remove them when running the command

// last 4 statuses are pulled from attributesToRetrieve in index
// is_duplicate and lastStatusChange might no longer be in use
